<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div v-if="successfully_feedback === false">
      <div id="url_expired" style="text-align: center; width: 90%;">
        <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="url_valid">
        <div style="text-align: center;">
          <h6 style="padding: 1%;">{{reportHeader}}</h6>
          <p style="padding: 1%;font-size:12px">{{reportBody}}</p>
          <br />
          <!--<iframe v-bind:src="'data:' + reportFormat + ';base64,' + reportContent" style="width:100vh; height:100vh"></iframe>
          <object><iframe v-bind:src="'data:' + reportFormat + ';base64,' + reportContent" style="width:100vh; height:100vh"></iframe></object>-->
          <!-- <a v-bind:href="reportContent"></a> -->
          <!-- <embed src="'data:' + reportFormat + ';base64,' + reportContent" type="application/pdf" style="height: 100vh; width:100vh" > -->
           <a v-bind:href="resource_name_with_path" type="application/pdf" @click="linkClick">View Test Report</a>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'
import LTable from 'src/components/UIComponents/Table.vue'
import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
import axios from 'axios'
export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard
  },
  data () {
    return {
      urlInterface: [],
      apiDataObj: [],
      successfully_feedback: false,
      isLoading: true,
      isFullPage: true,
      reportHeader: '',
      reportBody: '',
      // reportFormat: '',
      // reportContent: '',
      resource_name_with_path: ''
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      const params = new URLSearchParams()
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('tr1?')
      params.append('url_str', splitUrl[1])
      axios({
        url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      })
        .then(response => {
          this.urlInterface = {}
          if (
            response.data.status === '000001' ||
            response.data.status === '000002' ||
            response.data.status === '000003'
          ) {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
            this.isLoading = false
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
            this.isLoading = false
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
        })
    },
    linkClick () {
      this.isLoading = true
    },
    invokeUrlAction () {
      const params = new URLSearchParams()
      params.append('url_interface_id', this.urlInterface.url_interface_id)
      params.append('action_name', this.urlInterface.action_name)
      axios({
        url: process.env.BASE_API + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      })
        .then(response => {
          this.apiDataObj = {}
          var self = this
          switch (this.urlInterface.action_name) {
            case 'cow_milk_test_report':
              // debugger
              // console.log(response.data.action_response.report_content)
              self.reportHeader = response.data.action_response.report_header
              self.reportBody = response.data.action_response.report_body
              // self.reportFormat = response.data.action_response.report_format
              self.resource_name_with_path = response.data.action_response.resource_name_with_path
              self.isLoading = false
              break
            default:
              break
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
        })
    }
  }
}
</script>
<style>
.loading-icon:before {
  content: "Wait...";
}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tr1.vue